import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getFirebaseServices } from "@/lib/firebase/client";
import { signOut } from "firebase/auth";

export default function LogoutButton() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleLogout() {
    const services = getFirebaseServices();
    setLoading(true);
    try {
      // Only call signOut if there's a configured auth service and a current user
      if (services && services.auth && (services.auth.currentUser ?? null)) {
        await signOut(services.auth);
      }
    } catch (err) {
      console.error("Sign out failed", err);
    } finally {
      // Always redirect to the login page so user lands on auth
      navigate('/auth/login');
      setLoading(false);
    }
  }

  return (
    <button
      type="button"
      onClick={handleLogout}
      disabled={loading}
      className={`inline-flex w-full items-center justify-center gap-2 rounded-2xl px-3 py-2 text-sm font-medium transition ${
        loading
          ? "bg-white/5 text-white/70"
          : "bg-white/3 text-red-300 hover:bg-white/6"
      }`}
    >
      {loading ? "Signing out..." : "Sign out"}
    </button>
  );
}
